export const moduleConfig = {
    entityKey: 'reconciliation-reports',
    // Every navigate/link in the module builds from this (§1).
    basePath: '/reconciliation-reports',
    titles: {
        singular: 'Reconciliation Report',
        plural: 'Reconciliation Reports'
    }
}

// The id is COMPOSITE — `reconciliation-report:{channel}#{runDate}` — so it MUST be
// encodeURIComponent'd: a raw `#` is a fragment delimiter, the path would truncate, and
// the detail page would ask getReconciliationReport for a partial id. react-router v6
// useParams() decodes, so the detail page receives the original id.
export const detailPath = (id: string) => `${moduleConfig.basePath}/${encodeURIComponent(id)}`;
